import { makeStyles } from "tss-react/mui"
import { Grid, Typography } from "@mui/material"
import { LocalizedStrict } from "../../../../../modules/localization/components/AppLocalized"
import { StandardDialog } from "../../../dialogs/StandardDialog"
import { StandardButton } from "../../../buttons/StandardButton"

const useStyles = makeStyles()((theme) => ({
    updateDialogTitle: {
        paddingLeft: "1rem",
        paddingRight: "1rem",
    },
    container: {
        padding: "0 4rem 2rem",
        gap: "2rem",
        textAlign: "center",
    },
    button: {
        borderRadius: "0.5rem",
        paddingLeft: "2rem",
        paddingRight: "2rem",
    },
    cancelButton: {
        color: theme.palette.tailwind.slate[800],
    },
}))

type NoProductsDialogProps = Readonly<{
    handleCloseMainDialog: () => void
    handleOpenSelectPriceListsDialog?: () => void
    isError: boolean
}>

export function NoProductsDialog({
    handleCloseMainDialog,
    handleOpenSelectPriceListsDialog,
    isError,
}: NoProductsDialogProps) {
    const { classes, cx } = useStyles()

    const isAllButtons = !!handleOpenSelectPriceListsDialog

    return (
        <LocalizedStrict
            id={isError ? "create-order-no-longer-available-dialog-title" : "create-order-no-products-dialog-title"}
            attrs={{ dialogTitle: true }}
        >
            <StandardDialog
                open
                onClose={handleCloseMainDialog}
                maxWidthProp="sm"
                dialogTitle={isError ? "Price list no longer available" : "Pricelist has no products"}
                updateDialogClasses={{
                    dialogTitleContainer: classes.updateDialogTitle,
                }}
            >
                <Grid
                    container
                    justifyContent="center"
                    alignItems="center"
                    direction="column"
                    wrap="nowrap"
                    className={classes.container}
                >
                    {isError ? (
                        <LocalizedStrict id="create-order-no-longer-available-dialog-message">
                            <Typography variant="body1">
                                The price list used for this order is no longer available. Please pick another price
                                list to continue.
                            </Typography>
                        </LocalizedStrict>
                    ) : (
                        <LocalizedStrict id="create-order-no-products-dialog-message">
                            <Typography variant="body1">
                                Please contact the merchant to get access to the products
                            </Typography>
                        </LocalizedStrict>
                    )}
                    <Grid
                        container
                        direction="row"
                        wrap="nowrap"
                        alignItems="center"
                        justifyContent="center"
                        gap="1rem"
                    >
                        <LocalizedStrict id="create-order-no-products-dialog-button-label-cancel">
                            <StandardButton
                                color={isAllButtons ? "grey" : "black"}
                                variant={isAllButtons ? "outlined" : "contained"}
                                onClick={() => {
                                    handleCloseMainDialog()
                                }}
                                size="medium"
                                className={cx(isAllButtons ? classes.cancelButton : "")}
                                updateDefaultClasses={classes.button}
                                fullWidth={isAllButtons ?? false}
                            >
                                Go to home
                            </StandardButton>
                        </LocalizedStrict>
                        {isAllButtons && (
                            <LocalizedStrict id="create-order-no-products-dialog-button-label-submit">
                                <StandardButton
                                    onClick={() => {
                                        handleOpenSelectPriceListsDialog()
                                    }}
                                    size="medium"
                                    updateDefaultClasses={classes.button}
                                >
                                    Select another Pricelist
                                </StandardButton>
                            </LocalizedStrict>
                        )}
                    </Grid>
                </Grid>
            </StandardDialog>
        </LocalizedStrict>
    )
}
